<div *ngIf="showLoader" class="global-spinner" [style.position]="position">
  <div class="spinner-wrapper">
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      value="30"
      diameter="70"
    >
    </mat-progress-spinner>
  </div>
</div>
